import { Link } from 'react-router-dom';
import { Mic, Calendar, Clock, ArrowRight, Youtube, Headphones } from 'lucide-react';

const PodcastPage = () => {
  return (
    <div className="min-h-screen pt-20" data-testid="podcast-page">
      {/* Hero Section */}
      <section className="py-12 md:py-20 relative overflow-hidden" data-testid="podcast-hero">
        <div className="absolute inset-0 grid-bg opacity-30" />
        <div className="hero-glow top-0 left-1/4" />
        
        <div className="container-main relative z-10">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
            <div>
              <Link to="/services" className="inline-flex items-center gap-2 text-[var(--text-muted)] hover:text-[var(--primary)] mb-6 font-mono text-sm">
                <ArrowRight className="w-4 h-4 rotate-180" /> Back to Services
              </Link>
              <div className="flex items-center gap-4 mb-6">
                <div className="w-16 h-16 border border-[var(--accent-purple)] bg-[var(--accent-purple)]/10 flex items-center justify-center">
                  <Mic className="w-8 h-8 text-[var(--accent-purple)]" />
                </div>
                <div>
                  <p className="font-mono text-sm uppercase tracking-wider text-[var(--accent-purple)]">Video Podcast</p>
                  <h1 className="text-3xl md:text-5xl font-bold text-[var(--text-main)]">Byt3cast</h1>
                </div>
              </div>
              <p className="text-[var(--text-muted)] text-lg md:text-xl leading-relaxed mb-8">
                Weekly video podcast featuring interviews with security researchers, ethical hackers, 
                and industry leaders. Deep dives into the latest threats, tools, and career advice.
              </p>
              <div className="flex flex-wrap gap-4">
                <a href="https://www.youtube.com/@Byt3conAcademy" target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-2 bg-[#FF0000] text-white font-mono font-bold px-6 py-3 uppercase tracking-widest hover:bg-[#CC0000] transition-colors duration-200" data-testid="youtube-subscribe-btn">
                  <Youtube className="w-5 h-5" /> Subscribe
                </a>
                {/* <a href="https://spotify.com" target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-2 border border-[#1DB954] text-[#1DB954] font-mono px-6 py-3 uppercase tracking-widest hover:bg-[#1DB954]/10 transition-colors duration-200" data-testid="spotify-btn">
                  <Headphones className="w-5 h-5" /> Spotify
                </a> */}
              </div>
            </div>
            {/* Stats */}
            <div className="bg-[var(--surface)] border border-[var(--border)] p-8">
              <div className="flex items-center gap-2 mb-6 pb-4 border-b border-[var(--border)]">
                <div className="w-3 h-3 rounded-full bg-[#ff5f56]" />
                <div className="w-3 h-3 rounded-full bg-[#ffbd2e]" />
                <div className="w-3 h-3 rounded-full bg-[#27ca40]" />
                <span className="ml-4 font-mono text-sm text-[var(--text-muted)]">podcast_stats.sh</span>
              </div>
              <div className="grid grid-cols-2 gap-6">
                <div>
                  <p className="font-mono text-4xl font-bold text-[var(--accent-purple)]">200+</p>
                  <p className="text-[var(--text-muted)] text-sm">Episodes</p>
                </div>
                <div>
                  <p className="font-mono text-4xl font-bold text-[var(--accent-purple)]">50K+</p>
                  <p className="text-[var(--text-muted)] text-sm">Subscribers</p>
                </div>
                <div>
                  <p className="font-mono text-4xl font-bold text-[var(--accent-purple)]">Weekly</p>
                  <p className="text-[var(--text-muted)] text-sm">New Episodes</p>
                </div>
                <div>
                  <p className="font-mono text-4xl font-bold text-[var(--accent-purple)]">4.9</p>
                  <p className="text-[var(--text-muted)] text-sm">Rating</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Episodes List / Coming Soon */}
      <section className="py-16 md:py-24 relative overflow-hidden" data-testid="episodes-list">
        <div className="absolute inset-0 grid-bg opacity-30" />
        <div className="hero-glow top-0 right-1/4" />
        <div className="container-main relative z-10">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
            <div className="bg-[var(--surface)] border border-[var(--border)] p-8 md:p-12">
              <div className="space-y-6">
                <p className="text-[var(--accent-purple)] text-sm font-mono uppercase tracking-wider">Upcoming Episodes</p>
                <h2 className="text-3xl md:text-4xl font-bold text-[var(--text-main)]">Fresh Episodes Coming Soon</h2>
                <p className="text-[var(--text-muted)] text-lg leading-relaxed">We're preparing exclusive interviews with industry experts and thought leaders. Get ready for deep dives into the latest cybersecurity trends and tools.</p>
                <p className="text-[var(--text-muted)] text-base">Subscribe on YouTube to be notified when the first episodes launch.</p>
              </div>
            </div>
            <div className="bg-[var(--surface-highlight)] border border-[var(--border)] border-dashed p-8 md:p-12 flex flex-col items-center justify-center text-center space-y-4">
              <div className="text-5xl">🎙️</div>
              <p className="text-[var(--text-muted)] text-lg">New episodes arriving soon</p>
              <p className="text-sm text-[var(--text-muted)]">Follow us for updates on guest announcements and episode schedules.</p>
            </div>
          </div>
        </div>
      </section>

      {/* Subscribe Section */}
      <section className="py-12 md:py-20  border-t border-[var(--border)]" data-testid="podcast-subscribe">
        <div className="container-main text-center">
          <h2 className="text-2xl md:text-4xl font-bold text-[var(--text-main)] mb-4">Never Miss an Episode</h2>
          <p className="text-[var(--text-muted)] text-lg max-w-2xl mx-auto mb-8">
            Subscribe to Byt3cast on your favorite platform and get notified when new episodes drop.
          </p>
          <div className="flex flex-wrap justify-center gap-4">
            <a href="https://youtube.com" className="px-6 py-3 bg-[#FF0000] text-white font-mono uppercase tracking-wider hover:bg-[#CC0000] transition-colors duration-200">YouTube</a>
            {/* <a href="https://spotify.com" className="px-6 py-3 bg-[#1DB954] text-white font-mono uppercase tracking-wider hover:bg-[#1aa34a] transition-colors duration-200">Spotify</a> */}
            {/* <a href="https://podcasts.apple.com" className="px-6 py-3 bg-[#9933CC] text-white font-mono uppercase tracking-wider hover:bg-[#7a29a3] transition-colors duration-200">Apple Podcasts</a> */}
          </div>
        </div>
      </section>
    </div>
  );
};

export default PodcastPage;
